const STORAGE_KEY_PREFIX = 'sn:membership_type'

export type MembershipType = 'permission' | 'following'

const DEFAULT_MEMBERSHIP_TYPE: MembershipType = 'following'

export const saveMembershipType = (
  userId: string | number,
  type: MembershipType
): void => {
  try {
    const key = `${STORAGE_KEY_PREFIX}_${userId}`
    localStorage.setItem(key, type)
  } catch (error) {
    console.error('Error saving membership type:', error)
  }
}

export const loadMembershipType = (
  userId: string | number
): MembershipType => {
  try {
    const key = `${STORAGE_KEY_PREFIX}_${userId}`
    const stored = localStorage.getItem(key)
    if (stored === 'permission' || stored === 'following') {
      return stored
    }
    return DEFAULT_MEMBERSHIP_TYPE
  } catch (error) {
    console.error('Error loading membership type:', error)
    return DEFAULT_MEMBERSHIP_TYPE
  }
}
